import React from 'react';
import CustomizeDrawer from '../../../components/customize/CustomizeDrawer';
import { usePreviewContext } from '../providers/PreviewProvider';
import { useWorkspaceContext } from '../providers/WorkspaceProvider';

export default function StyleCustomizer() {
  const {
    accentColor,
    setAccentColor,
    fontFamily,
    setFontFamily,
    fontScale,
    setFontScale,
    theme,
  } = usePreviewContext();

  const { showCustomize, setShowCustomize } = useWorkspaceContext();

  return (
    <CustomizeDrawer
      open={showCustomize}
      onClose={() => setShowCustomize(false)}
      accentColor={accentColor}
      setAccentColor={setAccentColor}
      fontFamily={fontFamily}
      setFontFamily={setFontFamily}
      fontScale={fontScale}
      setFontScale={setFontScale}
      theme={theme}
    />
  );
}
